import { useHistory } from 'react-router-dom';
import { PrimaryButton } from '@weave/design-system';

export const JustifiPayoutsLink = ({ locationId }: { locationId: string }) => {
  const history = useHistory();

  const onNavigate = () => {
    history.push(`/location/${locationId}/settings/payments/justifi/disputes`);
  };
  return (
    <div css={{ width: 'max-content' }}>
      <PrimaryButton onClick={onNavigate}>View JustiFi Disputes</PrimaryButton>
    </div>
  );
};
